import React, { useEffect, useState } from 'react';
import cx from 'classnames';
import { SizeMe } from 'react-sizeme';
import { Icon, Text } from '../../../ui-kit';
import mediaSizes from '../../../common/constants/mediaSizes';
import getSubscriptionInfoFromContract from '../../../common/utils/getSubscriptionInfoFromContract';
import '../styles/_subscriptionInfo-v2.scss';

const TIER_COLORS = {
  Paid: '#e9f8f6',
  Trial: '#f69f1f',
  Free: '#d4d9e2'
};

const FONT_COLORS = {
  Paid: '#27baa1'
};

const ICON_NAMES = {
  Pro: 'procolor',
  Elevate: 'elevatecolor',
  Cast: 'castcolor'
};






export default function SubscriptionInfoV2(props) {
  const { getContracts, organisationId } = props;

  const [contractsData, setContractsData] = useState({});

  if (!getContracts) {return null;}

  const fetchData = async () => {
    const fetchedContractsData = await getContracts({ organisationId, status: 'ACTIVE' });
    setContractsData(fetchedContractsData);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (!contractsData ||
  !contractsData.data ||
  !contractsData.data.getContracts.length)
  {
    return null;
  }

  const contracts = contractsData.data.getContracts.reverse();

  const allSubscriptions = contracts.map((contract) => getSubscriptionInfoFromContract(contract));

  const subscriptions = allSubscriptions.filter((contract) => contract.name !== 'Workspace');

  return (
    <SizeMe>
      {({ size: { width } }) =>
      <div
        className={cx(
          'subscription-info-v2',
          { 'subscription-info--medium': width < mediaSizes.medium },
          { 'subscription-info--small': width < mediaSizes.small }
        )}>

          {subscriptions.map((subscription) =>
        <div
          className="subscription-info-v2__line-box"
          key={subscription.key}>

              <div className="subscription-info-v2__line-box__left">
                <div className="subscription-info-v2__line-box__left__text">
                  <Icon name={ICON_NAMES[subscription.name]} size={35} />
                  <div className="subscription-info-v2__line-box__left__text__title">
                    <Text
                  heading5
                  className="subscription-info-v2__line-box__left__text__title__product">

                      {subscription.name}
                    </Text>
                  </div>
                  <Text className="subscription-info-v2__line-box__left__text__info">{subscription.info}</Text>
                  <Text caption>{`Ends ${subscription.endDate}`}</Text>
                </div>
              </div>
              <div className="subscription-info-v2__line-box__right">
                <Text
              className="subscription-info-v2__line-box__right__tier">

                  <span style={{ background: TIER_COLORS[subscription.tier],
                color: FONT_COLORS[subscription.tier] }}>

                    {subscription.tier}
                  </span>
                </Text>
              </div>
            </div>
        )}

        </div>}

    </SizeMe>);

}